module.exports = __webpack_public_path__ + "static/media/rapidNaming-intro2.63e0b203.mp3";